import { logError } from "utils/error";
import { isInteger } from "utils/validations";
import constants from "constants/constants";
import { useExlyConnectStore } from "features/ExlyConnect/store/useExlyConnectStore";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { exly_connect_minutes_error_message } from "features/ExlyConnect/ExlyConnect.constants";

export const useExlyConnect = () => {
  const isValidZoomUser = useExlyConnectStore((state) => state.isValidZoomUser);
  const webinarMinutes = useExlyConnectStore((state) => state.webinarMinutes);
  const invalidZoomUserError = useExlyConnectStore(
    (state) => state.invalidZoomUserError
  );

  /**
   * Whether the user holds zoom license/credits to start exly zoom meeting/webinar
   * @param { 7 | 10 } address_type exly zoom/exly zoom webinar address type
   * @returns {boolean} can start meeting or not
   */
  const canStartExlyZoom = (address_type) => {
    if (!isInteger(address_type)) {
      logError({
        customErrorMessage: "non-integer address type",
        occuredAt:
          "src/features/ExlyConnect/modules/ExlyConnectMeetingCard/utils/useExlyConnect/canStartExlyZoom",
      });
      return SOMETHING_WENT_WRONG;
    }

    if (
      address_type !== constants.address_type_enum.exly_connect_by_zoom &&
      address_type !== constants.address_type_enum.exly_zoom_webinar
    ) {
      logError({
        customErrorMessage: "Only exly zoom/webinar address type allowed",
        occuredAt:
          "src/features/ExlyConnect/modules/ExlyConnectMeetingCard/utils/ExlyConnectMeetingCard",
      });
      return SOMETHING_WENT_WRONG;
    }

    if (!isValidZoomUser) {
      return invalidZoomUserError;
    }

    if (
      address_type === constants.address_type_enum.exly_zoom_webinar &&
      webinarMinutes <= 0 // only checking minutes in case of exly zoom webinar
    ) {
      return exly_connect_minutes_error_message;
    }
    return "";
  };

  return {
    canStartExlyZoom,
  };
};
